import {NodePlopAPI} from "plop";
import createModulePrompts from "../../prompts/nest/create-module-prompt";
import createModuleCrudDtoActions from "../../actions/nest/create-module-crud-dto-action";

const generator = (plop: NodePlopAPI) => {
    plop.setGenerator('nest:create:module:crud:dto', {
        description: 'application ressource logic',
        prompts: createModulePrompts,
        actions: [...createModuleCrudDtoActions],
    });
}

export default generator;
